import { Button, Card, Grid, Typography } from '@material-ui/core';
import AssembeliaDateTime from 'components/AssembleiaDateTime';
import AssembleiaPautas, { IPauta } from 'components/AssembleiaPautas/AssembleiaPautas';
import Breadcrumb from 'components/BreadCrumb/BreadCrumb';
import { IBreadCrumbItem } from 'components/BreadCrumb/BreadCrumbItem';
import { AlertIcon, EditIcon, PeopleIcon, PlayIcon, SyncIcon, TrashIcon } from 'components/Icons';
import InfoCard from 'components/LabelValueCard/LabelValueCard';
import PageTitle from 'components/PageTitle/PageTitle';
import Page from 'components/PrivateContainer';
import { parseISO } from 'date-fns';
import { AssembleiaStatus } from 'enuns/AssembleiaStatus';
import { AssessorTransmissaoRoutePath, MainRoutePath } from 'library/Routes';
import React, { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IReducer } from 'store/Reducer';
import Context from './Context';
import useStyle from './style';

export default () => {
  const {t} = useTranslation();
  const classes = useStyle();
  const { usuario } = useSelector((state: IReducer) => state.auth);
  const {
    loadingEvento,
    loadingPautas,
    evento,
    alterarSituacao,
    convocarEvento,
    convocando,
    bloquearEvento,
    bloqueando,
    atualizarPresencas,
    atualizandoPresencas,
    presencas,
  } = useContext(Context)
  
  const eventoNome = useMemo(() => {
    if (loadingEvento) {
      return t('AssembleiaAssessorRoute.carregando');
    }
    return evento?.nome || '';
  }, [t, evento, loadingEvento]);

  const eventoSituacao = useMemo(() => {
    if (loadingEvento) {
      return t('AssembleiaAssessorRoute.carregando');
    }
    return t(`AssembleiaStatus.${evento?.status || 0}`);
  }, [t, evento, loadingEvento]);

  const breadcrumb = useMemo(
    (): IBreadCrumbItem[] => [{ nome: t('MainRoute.title'), url: MainRoutePath }, { nome: eventoNome }],
    [t, eventoNome]
  );
  
  const openTransmissao = useCallback(() => {
    if (!evento?.urlTransmissao) return;
    const winUrl = AssessorTransmissaoRoutePath + `?url=${evento.urlTransmissao}`;
    const win = window.open(winUrl, '_blank');
    win?.focus();
  }, [evento]);

  return (
    <Page
      header={
        <React.Fragment>
          <PageTitle title={eventoNome} />
          <Breadcrumb itens={breadcrumb} />
        </React.Fragment>
      }
      headerClassName={classes.header}
      contentClassName={classes.content}
    >
      <Grid component="section" container spacing={2}>
        <Grid item xs={12} md={2}>
          <Typography component="h2" className={classes.situacao}>
            {t('AssembleiaAssessorRoute.situacao', { situacao: eventoSituacao })}
          </Typography>
        </Grid>
        <Grid item xs={12} md={5} className={classes.data}>
          {evento?.dataEvento && <AssembeliaDateTime date={parseISO(evento.dataEvento)} dateFim={parseISO(evento.dataEventoFim)} alignStart />}
        </Grid>
        <Grid item xs={12} md={5} className={classes.botoesSituacao}>
          {usuario?.perfil.assessorRoute.assembleias.alterarSituacao && !loadingEvento && (
            <React.Fragment>
              {!evento?.flgConvocado && usuario!.perfil.assessorRoute.assembleias.convocar && (
                <Button
                  variant="outlined"
                  color="primary"
                  // className={rootClassName + '-right-header-item'}
                  onClick={() => convocarEvento()}
                  disabled={convocando}
                  startIcon={convocando ? <SyncIcon animated /> : <PeopleIcon />}
                >
                  {t('AssembleiaAssessorRoute.convocarButton')}
                </Button>
              )}
              {evento?.flgConvocado && !evento?.flgBloqueio && usuario!.perfil.assessorRoute.assembleias.bloquearConvocacao && (
                <Button
                  variant="outlined"
                  disabled={bloqueando}
                  startIcon={bloqueando ? <SyncIcon animated /> : <TrashIcon />}
                  onClick={() => bloquearEvento()}
                  className={classes.botaoBloquear}
                >
                  {t('AssembleiaAssessorRoute.bloquearConvocacao')}
                </Button>
              )}
              {/* {needQuorumRegister && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={registraQuorum}
                  startIcon={registrandoQuorum ? <SyncIcon animated /> : <AssembleiaIcon />}
                >
                  {t('AssembleiaAssessorRoute.buttonRegistrarQuorum')}
                </Button>
              )} */}
              { evento?.status !== AssembleiaStatus.Encerrado &&
                <Button variant="contained" color="primary" onClick={() => alterarSituacao()} startIcon={<EditIcon />}>
                  {t('AssembleiaAssessorRoute.alteraSituacaoButton')}
                </Button>
              }
            </React.Fragment>
          )}
        </Grid>
        <Grid item xs={12} className={classes.updatePresence}>
          <Button
            variant="text"
            color="primary"
            onClick={() => atualizarPresencas()}
            endIcon={<SyncIcon animated={atualizandoPresencas} />}
            disabled={atualizandoPresencas}
          >
            <Typography component="p" className={classes.syncLabel}>
              {t('AssembleiaAssessorRoute.buttonAtualizarParticipantes')}
            </Typography>
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4} lg={3}>
              <InfoCard
                className={classes.infoCard}
                label={t(
                  `AssembleiaAssessorRoute.${
                    evento?.urlTransmissao ? 'buttonAssistirTransmissao' : 'buttonEditarTransmissao'
                  }`
                )}
                value={
                  loadingEvento ? (
                    <SyncIcon animated className={classes.labelValueIcon} />
                  ) : (
                    <PlayIcon className={classes.labelValueIcon} />
                  )
                }
                button
                onClick={() => openTransmissao()}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <InfoCard
                className={classes.infoCard}
                label={t('AssembleiaAssessorRoute.infoCardLabel.participantes')}
                value={loadingEvento || atualizandoPresencas ? '-' : presencas?.usuariosLogados || 0}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <InfoCard
                className={classes.infoCard}
                label={t('AssembleiaAssessorRoute.infoCardLabel.colaboradoresPresentes')}
                value={loadingEvento || atualizandoPresencas ? '-' : presencas?.colaboradoresPresentes || 0}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <InfoCard
                className={classes.infoCard}
                label={t('AssembleiaAssessorRoute.infoCardLabel.presentes')}
                value={loadingEvento || atualizandoPresencas ? '-' : presencas?.presentes || 0}
              />
            </Grid>
          </Grid>
        </Grid>
        {usuario!.perfil.assessorRoute.assembleias.pautas.ver && (
          <Grid item xs={12} className={classes.gridItem}>
            {loadingEvento || loadingPautas ? (
              <Card>
                <div className={classes.pautasWarning}>
                  <SyncIcon animated />
                  <Typography>{t('AssembleiaAssociadoRoute.pautas.loading')}</Typography>
                </div>
              </Card>
            ) : evento?.pautas?.length === 0 ? (
              <Card>
                <div className={classes.pautasWarning}>
                  <AlertIcon className={classes.pautaAlertIcon} />
                  <Typography>{t('AssembleiaAssociadoRoute.pautas.notFound')}</Typography>
                </div>
              </Card>
            ) : (
              <AssembleiaPautas pautas={evento!.pautas as IPauta[]} />
            )}
          </Grid>
        )}
      </Grid>
    </Page>
  )
}